var CollaborationServiceSetup = /** @class */ (function () {
    function CollaborationServiceSetup() {
    }
    CollaborationServiceSetup.Initialize = function (client, clientCore) {
        this._client = client;
        this._clientCore = clientCore;
    };
    Object.defineProperty(CollaborationServiceSetup, "client", {
        get: function () {
            return this._client;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollaborationServiceSetup, "clientCore", {
        get: function () {
            return this._clientCore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollaborationServiceSetup, "token", {
        set: function (val) {
            this._client.token = val;
            if (this._clientCore)
                this._clientCore.token = val;
        },
        enumerable: true,
        configurable: true
    });
    return CollaborationServiceSetup;
}());
export { CollaborationServiceSetup };
//# sourceMappingURL=Setup.js.map